import React from "react";
import { withRouter } from "react-router";

// Components
import HomeSidebar from "./home";
import ProductSidebar from "./product";
import UserSidebar from "./users";
import BankSidebar from "./banks";
import ZipSidebar from "./zip";
import VideoSidebar from "./videos";
import ServiceRequestSidebar from "./service-request";
import ContactUsSidebar from "./contact-us";
import HolidaySidebar from "./holidays-sidebar";
import AnnouncementSidebar from "./announcement-sidebar";

function Index(props) {
  return (
    <>
      {props.location.pathname === "/dashboard/home" && (
        <HomeSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          item_data={props.item_data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/product" && (
        <ProductSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/users" && (
        <UserSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          theme={props.theme}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/banks" && (
        <BankSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/zipcodes" && (
        <ZipSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/videos" && (
        <VideoSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/service-request" && (
        <ServiceRequestSidebar
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/contact-us" && (
        <ContactUsSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          item_data={props.item_data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/holidays" && (
        <HolidaySidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
      {props.location.pathname === "/dashboard/announcements" && (
        <AnnouncementSidebar
          response={(e) => props.response(e)}
          Type={props.Type}
          data={props.data}
          sidebar={props.sidebar}
          close={() => props.close()}
        />
      )}
    </>
  );
}

export default withRouter(Index);
